const RESPONSIBLE= {
    BASE: "Responsible",
    MAIN: undefined,
    ORDERS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined
    }
};

RESPONSIBLE.MAIN = `${RESPONSIBLE.BASE}|Main`

RESPONSIBLE.ORDERS._BASE = `${RESPONSIBLE.BASE}|Orders`
RESPONSIBLE.ORDERS.LIST = `${RESPONSIBLE.ORDERS._BASE}|List`
RESPONSIBLE.ORDERS.DETAIL = `${RESPONSIBLE.ORDERS._BASE}|Detail`

export default {
    ...RESPONSIBLE
}